import { render } from "./ReminderView.vue?vue&type=template&id=631faa26"
import script from "./ReminderView.vue?vue&type=script&lang=js"
export * from "./ReminderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__